import React, { use, useEffect, useState } from "react";
import CryptoJS from "crypto-js";

import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import dayjs from "dayjs";
import "../../../styles/Auth/employee.css";
import { EMPLOYEE_ROLES } from "../../../utils/constants.js";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip,
    Switch
} from '@mui/material';
import { Box, Modal, Button, IconButton, Chip } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";

const DetailItem = ({ label, value, fullWidth, icon, color = "#1a1e27" }) => (
    <Box sx={{
        gridColumn: fullWidth ? 'span 2' : 'span 1',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        pb: 1.5,
        mb: 0.5,
        borderBottom: '1px solid #f8fafc'
    }}>
        <Box sx={{
            color: color,
            display: 'flex',
            mt: 0.5,
            p: 1.2,
            borderRadius: '12px',
            bgcolor: `${color}15`, // Adding 15 for 8% opacity
            boxShadow: `0 4px 10px ${color}10`,
            border: `1px solid ${color}20`
        }}>
            {icon && <Icon icon={icon} style={{ fontSize: '18px' }} />}
        </Box>
        <Box sx={{ flex: 1 }}>
            <Typography
                variant="caption"
                sx={{
                    color: '#64748b',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontSize: '10px',
                    display: 'block',
                    mb: 0.2
                }}
            >
                {label}
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: '#1e293b',
                    fontWeight: 600,
                    wordBreak: 'break-word',
                    lineHeight: 1.4
                }}
            >
                {value || "-"}
            </Typography>
        </Box>
    </Box>
);

const SectionHeader = ({ icon, title, color = "#1a1e27" }) => (
    <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 3,
        mt: 1,
        pb: 1,
        borderBottom: '2px solid #f1f5f9'
    }}>
        <Box sx={{
            display: 'flex',
            p: 1,
            borderRadius: '10px',
            bgcolor: color,
            color: '#ffffff',
            boxShadow: `0 8px 16px ${color}30`
        }}>
            <Icon icon={icon} style={{ fontSize: '20px' }} />
        </Box>
        <Typography variant="subtitle1" fontWeight={700} color="#1a1e27">
            {title}
        </Typography>
    </Box>
);




const EmployeePage = ({ pageName }) => {
    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    // const departmentId = params.get("departmentId");
    const loggedInRole = localStorage.getItem("role");
    const adminStoreIds = React.useMemo(() => JSON.parse(localStorage.getItem("storeIds") || "[]"), []);
    const initialStoreId = adminStoreIds[0] || "";
    const isAddEmployee = location.pathname === '/employees/add';
    const isStoreAdmin = location.pathname === '/store-admin/add';

    const isStoreAdminRole = (r) => {
        if (!r) return false;
        const normalized = r.toString().trim().toLowerCase().replace(/[\s_-]+/g, '');
        return normalized === "storeadmin";
    };
    const [searchQuery, setSearchQuery] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [IdPreviewUrl, setIdPreviewUrl] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [employeeImage, setEmployeeImage] = useState(null);
    const [IdProofImage, setIdProofImage] = useState(null);
    const [showIdProof, setShowIdProof] = useState(false);
    const [users, setUsers] = useState([]);
    // const [stores, setStores] = useState([]);
    // const [departments, setDepartments] = useState([]);
    const [open, setOpen] = useState(false);
    const [storeOptions, setStoreOptions] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [employeeToDelete, setEmployeeToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    // Role the employee had when the Edit modal was opened
    const [originalEditRole, setOriginalEditRole] = useState("");
    const [isViewEmployeePopup, setIsViewEmployeePopup] = useState(false);
    const [viewEmployeeData, setViewEmployeeData] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isAttendanceMode, setIsAttendanceMode] = useState(false);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const sort = [[sortField, sortOrder]];
    const [selectedStores, setSelectedStores] = useState([]);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [dynamicRoles, setDynamicRoles] = useState([]);



    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');

    const [isAddRoleModalOpen, setIsAddRoleModalOpen] = useState(false);
    const [editingRoleId, setEditingRoleId] = useState(null);
    const [editingRoleOldName, setEditingRoleOldName] = useState("");
    const [newRoleData, setNewRoleData] = useState({ roleName: '' });

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        role: '',
        phoneNumber: '',
        gender: '',
        employeeImageObject: '',
        password: '',
        confirmPassword: '',
        staffId: '',
        dateOfBirth: '',
        dateOfJoining: '',
        dateOfResignation: '',
        age: '',
        currentAddress: '',
        permanentAddress: '',
        bloodGroup: '',
        emergencyContactPerson: '',
        emergencyContactNumber: '',
        idProoftype: '',
        idProofImageObject: '',
        refferedByName: '',
        refferedByContactNumber: '',
        storeIds: [],
        isActive: true

    });

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const selectedRoleStoreId =
                    formData.storeIds?.[0] ||
                    selectedStores?.[0]?.value ||
                    selectedStoreId;

                const params = selectedRoleStoreId
                    ? { storeId: selectedRoleStoreId }
                    : {};
                const response = await getData('roles', params, sessionToken);
                if (response?.data) {
                    setDynamicRoles(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch dynamic roles", error);
            }
        };
        if (sessionToken) {
            fetchRoles();
        }
    }, [
        sessionToken,
        selectedStoreId,
        refreshKey,
        formData.storeIds,
        selectedStores
    ]);

    const handleOpenAddRoleModal = () => {
        setEditingRoleId(null);
        setEditingRoleOldName("");
        setNewRoleData({ roleName: '' });
        setIsAddRoleModalOpen(true);
    };

    const handleOpenEditRoleModal = (roleToEdit) => {
        const roleObj = typeof roleToEdit === 'string'
            ? dynamicRoles.find(r => r.roleName === roleToEdit)
            : roleToEdit;

        if (!roleObj) {
            toast.info("Selected role is a predefined system role and cannot be modified.");
            return;
        }

        setEditingRoleId(roleObj._id);
        setEditingRoleOldName(roleObj.roleName);
        setNewRoleData({
            roleName: roleObj.roleName
        });
        setIsAddRoleModalOpen(true);
    };

    const handleSaveRole = async () => {
        const trimmedRoleName = newRoleData.roleName?.trim();
        if (!trimmedRoleName) {
            toast.error("Role name is required");
            return;
        }
        if (isStoreAdminRole(trimmedRoleName)) {
            toast.error("Store Admin is a reserved role and cannot be created or modified as a custom role.");
            return;
        }

        try {
            const token = localStorage.getItem("Token");

            if (editingRoleId) {
                // 🔄 UPDATE EXISTING ROLE
                const payload = {
                    roleName: trimmedRoleName
                };
                const response = await putData(`roles/${editingRoleId}`, payload, token);
                if (response?.status === 200 || response?.success) {
                    toast.success("Role updated successfully");

                    // Update dynamic roles locally so it appears in dropdown immediately
                    setDynamicRoles(prev => prev.map(r =>
                        r._id === editingRoleId || r.roleName === editingRoleOldName
                            ? { ...r, roleName: trimmedRoleName }
                            : r
                    ));

                    // If currently selected role in form was the old name, update it to the new name
                    if (formData.role === editingRoleOldName) {
                        setFormData(prev => ({ ...prev, role: trimmedRoleName }));
                    }

                    setIsAddRoleModalOpen(false);
                    setEditingRoleId(null);
                    setEditingRoleOldName("");
                    setNewRoleData({ roleName: '' });
                    setRefreshKey(prev => prev + 1);
                } else {
                    toast.error(response?.message || "Failed to update role");
                }
            } else {
                // ➕ CREATE NEW ROLE
                const payload = {
                    roleName: trimmedRoleName,
                    storeId:
                        formData.storeIds?.[0] ||
                        selectedStores?.[0]?.value ||
                        initialStoreId ||
                        null
                };
                const response = await postData('roles', payload, token);
                if (response?.status === 200 || response?.success) {
                    toast.success("Role added successfully");
                    const createdRole = response?.data || { roleName: trimmedRoleName };
                    setDynamicRoles(prev => [...prev, createdRole]);
                    setFormData(prev => ({ ...prev, role: trimmedRoleName }));

                    setIsAddRoleModalOpen(false);
                    setNewRoleData({ roleName: '' });
                    setRefreshKey(prev => prev + 1);
                } else {
                    toast.error(response?.message || "Failed to add role");
                }
            }
        } catch (error) {
            console.error("Save Role Error:", error);
            toast.error("An error occurred while saving the role");
        }
    };

    const handleDeleteRole = async (roleObj) => {
        if (!roleObj?._id) return;
        if (!window.confirm(`Are you sure you want to delete role "${roleObj.roleName}"?`)) {
            return;
        }
        try {
            const token = localStorage.getItem("Token");
            const response = await deleteData(`roles/${roleObj._id}`, token);
            if (response?.status === 200 || response?.success) {
                toast.success("Role deleted successfully");
                setDynamicRoles(prev => prev.filter(r => r._id !== roleObj._id));
                if (formData.role === roleObj.roleName) {
                    setFormData(prev => ({ ...prev, role: "" }));
                }
                if (editingRoleId === roleObj._id) {
                    setEditingRoleId(null);
                    setEditingRoleOldName("");
                    setNewRoleData({ roleName: '' });
                }
                setRefreshKey(prev => prev + 1);
            } else {
                toast.error(response?.message || "Failed to delete role");
            }
        } catch (error) {
            console.error("Delete Role Error:", error);
            toast.error("An error occurred while deleting the role");
        }
    };

    const [currentDateTime, setCurrentDateTime] = useState("");
    const [isAddStore, setIsAddStore] = useState(false);
    const [errors, setErrors] = useState({});
    const selectedStoreCount = selectedStores?.length || 0;

    const handleViewEmployee = async (employeeId) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(`users/user/${employeeId}`, {}, token);
            if (res?.data) {
                const data = Array.isArray(res.data) ? res.data[0] : res.data;

                // ✅ If the API returns IDs instead of populated store names,
                // fallback to the data we already have in the 'users' list.
                if (data && (!data.store || data.store.length === 0 || typeof data.store[0] === "string")) {
                    const localUser = users.find(u => u._id === employeeId);
                    if (localUser?.store) {
                        data.store = localUser.store;
                    }
                }



                setViewEmployeeData(data);
                setIsViewEmployeePopup(true);
            }
        } catch (error) {
            console.error("View Employee Error:", error);
            toast.error("Failed to load employee details");
        }
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const validateEmail = (email) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const rolesRequiringEmail = ["StoreManager", "Biller", "StoreAdmin", "ClusterManager"];

    const handleEmailChange = (e) => {
        const email = e.target.value.toLowerCase();

        setFormData((prev) => ({
            ...prev,
            email
        }));

        const requiresEmail = rolesRequiringEmail.includes(formData.role);

        // Only validate if role requires email
        if (requiresEmail) {
            if (!email.trim()) {
                setEmailError("Email is required");
            } else if (!validateEmail(email)) {
                setEmailError("Please enter a valid email address");
            } else {
                setEmailError("");
            }
        } else {
            // Optional email for dynamic roles
            if (email && !validateEmail(email)) {
                setEmailError("Please enter a valid email address");
            } else {
                setEmailError("");
            }
        }
    };

    const isPasswordRequired = pageName === "StoreAdmin"
        ? true
        : ["StoreManager", "Biller"].includes(formData.role);


    const validateFields = (data, employeeImage) => {
        let newErrors = {};

        if (!data.name?.trim()) newErrors.name = "Name is required";
        if (data.phoneNumber && !/^[6-9]\d{9}$/.test(data.phoneNumber))
            newErrors.phoneNumber = "Enter a valid phone number";
        if (!data.storeIds || data.storeIds.length === 0) {
            newErrors.storeIds = "Please select at least one store";
        }
        if (!data.role) newErrors.role = "Role is required";
        if (!data.gender) newErrors.gender = "Gender is required";
        const rolesRequiringEmail = ["StoreManager", "Biller", "StoreAdmin", "ClusterManager"];
        if (rolesRequiringEmail.includes(data.role)) {
            if (!data.email) newErrors.email = "Email is required";
            else if (!/^\S+@\S+\.\S+$/.test(data.email))
                newErrors.email = "Invalid email format";
        }
        // For other roles, email is fully optional — no validation needed

        if (isPasswordRequired) {
            if (!data.password) newErrors.password = "Password is required";
            else if (data.password.length < 6)
                newErrors.password = "Min 6 characters";

            if (!data.confirmPassword)
                newErrors.confirmPassword = "Confirm password is required";
            else if (data.password !== data.confirmPassword)
                newErrors.confirmPassword = "Passwords do not match";
        }

        if (!data.dateOfJoining) newErrors.dateOfJoining = "Date of Joining is required";
        console.log("ROLE =", data.role);
        console.log("EMAIL =", data.email);
        return newErrors;
    };

    useEffect(() => {
        // 🔒 Auto-select store for StoreAdmin & StoreManager with ONE store
        if (isAddEmployee && (loggedInRole === "StoreAdmin" || loggedInRole === "StoreManager") && adminStoreIds.length === 1) {
            const storeId = adminStoreIds[0];

            // Only fetch if not already loaded or correctly selected
            if (store.length > 0 && store[0].value === storeId) return;

            const fetchStoreName = async () => {
                try {
                    const token = localStorage.getItem("Token");
                    const res = await getData(`stores/store/${storeId}`, {}, token);

                    if (res?.data) {
                        const storeOption = {
                            value: storeId,
                            label: res.data.storeName
                        };

                        setSelectedStores([storeOption]);

                        setFormData(prev => ({
                            ...prev,
                            storeIds: [storeId]
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            };

            fetchStoreName();
        }
    }, [isAddEmployee, loggedInRole, adminStoreIds, store]);


    const handleAddEmployee = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(
            formData,
            employeeImage
        );

        console.log(validationErrors);


        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        if (pageName !== "StoreAdmin" && isStoreAdminRole(formData.role)) {
            toast.error("Creation or assignment of Store Admin role is not permitted on the Employee page.");
            return;
        }

        setErrors({});
        setErrors({});
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let employeeImageObject = null;
            let idProofImageObject = null;

            // ✅ Upload Employee Image
            if (employeeImage && userId) {
                const uploadRes = await uploadFile(`files/upload/${userId}`, employeeImage);
                if (uploadRes?.status === 200 || uploadRes?.success) {
                    employeeImageObject = uploadRes.data;
                } else {
                    toast.error("Employee image upload failed");
                    setShowLoader(false);
                    return;
                }
            }

            // ✅ Upload ID Proof Image
            if (IdProofImage && userId) {
                const uploadRes = await uploadFile(`files/upload/${userId}`, IdProofImage);
                if (uploadRes?.status === 200 || uploadRes?.success) {
                    idProofImageObject = uploadRes.data;
                } else {
                    toast.error("ID proof image upload failed");
                    setShowLoader(false);
                    return;
                }
            }

            const employeeData = {
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                role: formData.role,
                phoneNumber: formData.phoneNumber,
                staffId: formData.staffId,
                password: isPasswordRequired ? (formData.password || "") : formData.phoneNumber,
                dateOfBirth: formData.dateOfBirth,
                dateOfJoining: formData.dateOfJoining,
                dateOfResignation: formData.dateOfResignation,
                age: formData.age,
                currentAddress: formData.currentAddress,
                permanentAddress: formData.permanentAddress,
                bloodGroup: formData.bloodGroup,
                emergencyContactPerson: formData.emergencyContactPerson,
                emergencyContactNumber: formData.emergencyContactNumber,
                idProoftype: formData.idProoftype,
                idProofImageObject: idProofImageObject,
                refferedByName: formData.refferedByName,
                refferedByContactNumber: formData.refferedByContactNumber,
                employeeImageObject,
                isActive: formData.isActive !== undefined ? formData.isActive : true,
                hasPosAccess: formData.hasPosAccess === true,
                source: pageName === "StoreAdmin" ? "StoreAdmin" : "Employee",
                isEmployeeCreation: pageName !== "StoreAdmin",
            };

            if (Array.isArray(formData.storeIds) && formData.storeIds.length > 0) {
                employeeData.storeIds = formData.storeIds;
            }

            console.log("FINAL PAYLOAD:", employeeData);

            const response = await postData("users/signup", employeeData, token);

            if (response?.status === 200 || response?.success) {
                const toastLabel = pageName === "StoreAdmin" ? "Store Admin" : "Employee";
                toast.success(response.message || `${toastLabel} added successfully`);

                setFormData({});
                setEmployeeImage(null);
                setPreviewUrl(null);
                setErrors({});
                pageName === "StoreAdmin" ? navigate("/store-admin") : navigate("/employees");
                fetchEmployees();
                triggerRefresh();
            } else {
                const toastLabel = pageName === "StoreAdmin" ? "Store Admin" : "Employee";
                toast.error(response?.message || `Failed to add ${toastLabel}`);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message || `Add ${pageName === "StoreAdmin" ? "Store Admin" : "Employee"} Failed`);
        } finally {
            setTimeout(() => setShowLoader(false), 1000);
        }
    };


    useEffect(() => {

        // Wait until dynamic roles are loaded
        if (
            dynamicRoles.length === 0 &&
            !["StoreManager", "Biller"].includes(loggedInRole)
        ) {
            return;
        }

        fetchEmployees(currentPage, limit, searchQuery, selectedStoreId);

    }, [
        currentPage,
        limit,
        refreshKey,
        searchQuery,
        selectedStoreId,
        sortField,
        sortOrder,
        pageName,
        store,
        dynamicRoles
    ]);

    const fetchEmployees = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            search: searchQuery?.trim() || "",
            role: pageName === "StoreAdmin"
                ? ["StoreAdmin"]
                : (["FranchiseAdmin", "SelfAdmin"].includes(loggedInRole)
                    ? ["ClusterManager", "Biller", "StoreManager", ...dynamicRoles.map(r => r.roleName)]
                    : ["Biller", "StoreManager", ...dynamicRoles.map(r => r.roleName).filter(r => r !== "ClusterManager")]),
            sort: JSON.stringify([[sortField, sortOrder]])
        }
        const sid = loggedInRole === "SuperAdmin" || loggedInRole === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        try {
            setLoading(true);
            const response = await getData('users/users', params, sessionToken);
            if (response?.status !== 200) {
                toast.error(response?.message || `Failed to fetch ${pageName === "StoreAdmin" ? "store admins" : "employees"}`);
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const employeeList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setUsers(employeeList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateEmployee = async (e) => {
        e.preventDefault();

        setShowLoader(true);


        try {
            if (pageName !== "StoreAdmin" && isStoreAdminRole(formData.role)) {
                toast.error("Creation or assignment of Store Admin role is not permitted on the Employee page.");
                setShowLoader(false);
                return;
            }

            if (!formData.role) {
                toast.error("Please select a role");
                setShowLoader(false);
                return;
            }

            // Switching into a login role (e.g. Stylist -> Biller) needs a new password
            const isRoleChanged = formData.role !== originalEditRole;
            const wasPasswordRole = pageName === "StoreAdmin" || ["StoreManager", "Biller"].includes(originalEditRole);
            if (isRoleChanged && isPasswordRequired && !wasPasswordRole && !formData.password) {
                toast.error(`Password is required when changing the role to ${formData.role}`);
                setShowLoader(false);
                return;
            }

            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = formData.employeeImageObject;
            let updatedIdImageObject = formData.idProofImageObject;

            if (employeeImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, employeeImage);
                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                }
            }

            if (IdProofImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, IdProofImage);
                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedIdImageObject = uploadResult.data;
                }
            }

            if (isPasswordRequired && formData.password) {
                if (formData.password.length < 6) {
                    toast.error("Password must be at least 6 characters");
                    setShowLoader(false);
                    return;
                }
                if (formData.password !== formData.confirmPassword) {
                    toast.error("Passwords do not match");
                    setShowLoader(false);
                    return;
                }
            }

            const updatedEmployeeData = {
                name: formData.name,
                email: formData.email,
                phoneNumber: formData.phoneNumber,
                role: formData.role,
                gender: formData.gender,
                employeeImageObject: updatedImageObject,
                departmentId: formData.departmentId,
                staffId: formData.staffId,
                dateOfBirth: formData.dateOfBirth,
                dateOfJoining: formData.dateOfJoining,
                dateOfResignation: formData.dateOfResignation,
                age: formData.age,
                currentAddress: formData.currentAddress,
                permanentAddress: formData.permanentAddress,
                bloodGroup: formData.bloodGroup,
                emergencyContactPerson: formData.emergencyContactPerson,
                emergencyContactNumber: formData.emergencyContactNumber,
                idProoftype: formData.idProoftype,
                idProofImageObject: updatedIdImageObject,
                refferedByName: formData.refferedByName,
                refferedByContactNumber: formData.refferedByContactNumber,
                isActive: formData.isActive,
                hasPosAccess: formData.hasPosAccess,
                source: pageName === "StoreAdmin" ? "StoreAdmin" : "Employee",
                isEmployeeUpdate: pageName !== "StoreAdmin",
            };

            if (isPasswordRequired) {
                if (formData.password) {
                    updatedEmployeeData.password = formData.password;
                    updatedEmployeeData.confirmPassword = formData.confirmPassword;
                }
            } else {
                updatedEmployeeData.password = formData.phoneNumber;
                updatedEmployeeData.confirmPassword = formData.phoneNumber;
            }

            if (Array.isArray(formData.storeIds) && formData.storeIds.length > 0) {
                updatedEmployeeData.storeIds = formData.storeIds;
            }

            console.log("Updating Employee with data:", updatedEmployeeData);

            const response = await putData(
                `users/user/${editEmployeeId}`,
                updatedEmployeeData,
                token
            );

            const toastLabel = pageName === "StoreAdmin" ? "Store Admin" : "Employee";
            if (!response || response.success === false) {
                toast.error(response?.message || `Failed to update ${toastLabel}`);
                return;
            }
            toast.success(response.message || `${toastLabel} updated successfully`);

            setFormData({
                name: "",
                email: "",
                phoneNumber: "",
                role: "",
                gender: "",
                employeeImageObject: "",
                storeId: "",
                departmentId: "",
                staffId: "",
                password: "",
                confirmPassword: "",
                dateOfBirth: "",
                dateOfJoining: "",
                dateOfResignation: "",
                age: "",
                currentAddress: "",
                permanentAddress: "",
                bloodGroup: "",
                emergencyContactPerson: "",
                emergencyContactNumber: "",
                idProoftype: "",
                idProofImageObject: "",
                refferedByName: "",
                refferedByContactNumber: ""
            });

            setEmployeeImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);

            fetchEmployees(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error(error.message || `Error updating ${pageName === "StoreAdmin" ? "Store Admin" : "Employee"}.`);
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };

    const handleDeleteEmployee = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`users/user/${employeeToDelete}`, token);
            const toastLabel = pageName === "StoreAdmin" ? "Store Admin" : "Employee";
            toast.success(response.message || `${toastLabel} deleted successfully`);
            setEmployeeToDelete(null);
            fetchEmployees(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || `Failed to delete ${pageName === "StoreAdmin" ? "Store Admin" : "Employee"}`);
        }
    }

    const handleTogglePosAccess = async (user, newStatus) => {
        try {
            const token = localStorage.getItem('Token');

            // Optimistic Update
            setUsers(prev => prev.map(u => u._id === user._id ? { ...u, hasPosAccess: newStatus } : u));

            const response = await putData(
                `users/user/${user._id}`,
                { hasPosAccess: newStatus },
                token
            );

            if (response?.status === 200 || response?.success || response?.data) {
                toast.success(response.message || "POS Access updated successfully");
                triggerRefresh();
            } else {
                setUsers(prev => prev.map(u => u._id === user._id ? { ...u, hasPosAccess: user.hasPosAccess } : u));
                toast.error(response?.message || "Failed to update POS Access");
            }
        } catch (error) {
            console.error("POS Access update error:", error);
            setUsers(prev => prev.map(u => u._id === user._id ? { ...u, hasPosAccess: user.hasPosAccess } : u));
            toast.error(error.message || "Failed to update POS Access status");
        }
    };

    const handleToggleStatus = async (user, newStatus) => {
        try {
            const token = localStorage.getItem('Token');

            // Optimistic Update
            setUsers(prev => prev.map(u => u._id === user._id ? { ...u, isActive: newStatus } : u));

            const response = await putData(
                `users/user/${user._id}`,
                { isActive: newStatus },
                token
            );

            if (response?.status === 200 || response?.success || response?.data) {
                toast.success(response.message || "Status updated successfully");
                triggerRefresh();
            } else {
                setUsers(prev => prev.map(u => u._id === user._id ? { ...u, isActive: user.isActive } : u));
                toast.error(response?.message || "Failed to update status");
            }
        } catch (error) {
            console.error("Status update error:", error);
            setUsers(prev => prev.map(u => u._id === user._id ? { ...u, isActive: user.isActive } : u));
            toast.error(error.message || "Failed to update status");
        }
    };

    // useEffect(() => {
    //     const fetchStores = async () => {
    //         try {
    //             const token = localStorage.getItem("Token");
    //             const data = await getData("stores/stores", {}, token);
    //             console.log("API Full Response:", data);

    //             const results = data?.data?.results || [];
    //             setStores(results);
    //         } catch (error) {
    //             console.error("Failed to load stores", error);
    //         }
    //     };
    //     fetchStores();
    // }, []);

    // useEffect(() => {
    //     const fetchDepartments = async () => {
    //         try {
    //             const token = localStorage.getItem("Token");
    //             const data = await getData('departments/departments', {}, token);
    //             console.log('API Full Response:', data);
    //             const results = data?.data?.[0]?.paginatedResults || [];
    //             setDepartments(results);

    //         } catch (error) {
    //             console.error("Failed to load sub categories", error);
    //         }
    //     };
    //     fetchDepartments();
    // }, []);

    useEffect(() => {
        let interval;
        if (isAttendanceMode) {
            setCurrentDateTime(dayjs().format("DD/MM/YYYY hh:mm A"));
            interval = setInterval(() => {
                setCurrentDateTime(dayjs().format("DD/MM/YYYY hh:mm A"));
            }, 1000); // update every second
        }
        return () => clearInterval(interval);
    }, [isAttendanceMode]);

    const handleOpen = (employeeId) => {
        setEmployeeToDelete(employeeId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEmployeeToDelete(null);
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const markAttendance = async (employeeId, status, date) => {
        try {
            const token = localStorage.getItem("Token");
            const today = new Date().toISOString().split('T')[0];
            const body = { employeeId, date: today, status };
            const response = await postData("users/user/attendance", body, token);
            toast.success(response.message || "Attendance marked successfully");
            setIsAttendanceMode(true);
        } catch (error) {
            console.error("Error marking attendance:", error);
            toast.error("Failed to mark attendance");
        }
    }

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };

    const headings = [
        'S.NO',
        'Image',
        'Name',
        'Email',
        'Phone Number',
        'Role',
        'Store',
        'StaffId',
        ...(["SuperAdmin", "SelfAdmin"].includes(loggedInRole) ? ['POS Access'] : []),
        'Status',
        // 'Attendance',
        'Action',
    ];

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleChange = e => {
        const { name, value } = e.target;
        // For firstName and lastName: only alphabets, no spaces
        if ((name === 'firstName' || name === 'lastName')) {

            if (/[^a-zA-Z]/.test(value)) return;

            const capitalizedValue =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

            setFormData((prev) => ({
                ...prev,
                [name]: capitalizedValue,
            }));
            return;
        }

        if (name === 'confirmPassword' || name === 'password') {
            const newPassword = name === 'password' ? value : formData.password;
            const newConfirm = name === 'confirmPassword' ? value : formData.confirmPassword;

            if (newPassword && newConfirm && newPassword !== newConfirm) {
                setPasswordMatchError('Passwords do not match');
            } else {
                setPasswordMatchError('');
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    function calculateAge(dob) {
        if (!dob) return "";
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }


    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };
        setLoading(true);
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    let allowedEmployeeRoles = [];

    if (pageName === "StoreAdmin") {
        allowedEmployeeRoles = ["StoreAdmin"];
    } else {
        const fixedRoles = [
            "StoreManager",
            "Biller",
            "ClusterManager"
        ];

        // Remove duplicates and exclude StoreAdmin roles
        const dynamicRoleNames = dynamicRoles
            .map(r => r.roleName)
            .filter(r => !isStoreAdminRole(r));

        const allAvailableRoles = [
            ...new Set([
                ...fixedRoles,
                ...dynamicRoleNames
            ])
        ].filter(r => !isStoreAdminRole(r));

        if (["FranchiseAdmin", "SelfAdmin"].includes(loggedInRole)) {
            allowedEmployeeRoles = allAvailableRoles;
        }
        else if (loggedInRole === "SuperAdmin") {
            allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "ClusterManager");
        }
        else if (loggedInRole === "StoreAdmin") {
            allowedEmployeeRoles = allAvailableRoles.filter(
                role =>
                    role !== "ClusterManager" &&
                    (role === "StoreManager" ||
                        role === "Biller" ||
                        dynamicRoleNames.includes(role))
            );
        }
        else if (loggedInRole === "ClusterManager") {
            allowedEmployeeRoles = allAvailableRoles.filter(
                role =>
                    role !== "ClusterManager" &&
                    (role === "StoreManager" ||
                        role === "Biller" ||
                        dynamicRoleNames.includes(role))
            );
        }
        else if (loggedInRole === "StoreManager") {
            allowedEmployeeRoles = allAvailableRoles.filter(
                role =>
                    role !== "ClusterManager" &&
                    (role === "Biller" ||
                        dynamicRoleNames.includes(role))
            );
        }
        else {
            allowedEmployeeRoles = [];
        }

        // Strictly guarantee Store Admin is not in employee roles
        allowedEmployeeRoles = allowedEmployeeRoles.filter(r => !isStoreAdminRole(r));
    }


    const formatDateTime = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toISOString().slice(0, 16);
    };

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        if (pageName === "StoreAdmin" || isStoreAdmin) {
            setFormData(prev => ({
                ...prev,
                role: "StoreAdmin",
            }));
        }
    }, [pageName, isStoreAdmin]);


    const handleDateChange = (fieldName, value) => {
        if (!value) {
            setFormData(prev => ({ ...prev, [fieldName]: value }));
            return;
        }

        // YYYY-MM-DD → extract year
        const year = value.split("-")[0];

        if (year.length > 4) {
            toast.error("Year should contain only 4 digits");
            return; // 🚫 block update
        }

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    useEffect(() => {
        if (isAddEmployee && initialStoreId) {
            setFormData(prev => ({
                ...prev,
                storeId: initialStoreId
            }));
        }
    }, [isAddEmployee, initialStoreId]);

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className="product-main">
                    {isAddEmployee ? (
                        <div className="add-Product-form">
                            <Typography variant="h6" mb={2}>
                                Add Employee
                            </Typography>
                            <form className="employee-form" onSubmit={handleAddEmployee}>
                                <div className="employee-form-row">
                                    <div className="employee-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="employeeImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="employeeImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.size > 1024 * 1024) {
                                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                            e.target.value = "";
                                                            return;
                                                        }
                                                        setEmployeeImage(file);
                                                        setPreviewUrl(URL.createObjectURL(file));
                                                    }}
                                                />

                                            </label>
                                            {errors.employeeImage && <p className="field-error">{errors.employeeImage}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="name" className="input-label">
                                            Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter employee name"
                                            className="category-input"
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                        {errors.name && <p className="field-error">{errors.name}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label className="input-label">Store Name</label>

                                        <StoreMultiSelect
                                            value={selectedStores}
                                            onChange={(val) => {
                                                // 🔒 Block change for StoreAdmin & StoreManager with ONE store
                                                if (
                                                    (loggedInRole === "StoreAdmin" || loggedInRole === "StoreManager") &&
                                                    adminStoreIds.length === 1
                                                ) return;

                                                setSelectedStores(val);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeIds: val.map(v => v.value)
                                                }));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={loggedInRole}
                                            assignedStoreIds={adminStoreIds}
                                            onAddStore={() => setIsAddStore(true)}
                                            isDisabled={
                                                (loggedInRole === "StoreAdmin" || loggedInRole === "StoreManager") &&
                                                adminStoreIds.length === 1
                                            }
                                        />


                                    </div>

                                    <div className="employee-form-group">
                                        <label htmlFor="role" className="input-label">
                                            Role
                                            <span className="required">*</span>
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <select
                                                id="role"
                                                className="category-input"
                                                value={formData.role}
                                                onChange={(e) => {
                                                    const selectedRole = e.target.value;

                                                    if (pageName !== "StoreAdmin" && isStoreAdminRole(selectedRole)) {
                                                        toast.error("Store Admin role cannot be assigned to an employee.");
                                                        return;
                                                    }

                                                    const isPwdReq = pageName === "StoreAdmin" ? true : ["StoreManager", "Biller"].includes(selectedRole);

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        role: selectedRole,
                                                        ...(!isPwdReq ? { password: '', confirmPassword: '' } : {})
                                                    }));

                                                    if (!isPwdReq) {
                                                        setErrors(prev => {
                                                            const newErr = { ...prev };
                                                            delete newErr.password;
                                                            delete newErr.confirmPassword;
                                                            return newErr;
                                                        });
                                                    }

                                                    const rolesRequiringEmail = ["StoreManager", "Biller", "StoreAdmin", "ClusterManager"];

                                                    // Clear email validation when role doesn't require email
                                                    if (!rolesRequiringEmail.includes(selectedRole)) {
                                                        setEmailError("");
                                                    } else {
                                                        // Validate existing email for required roles
                                                        if (!formData.email?.trim()) {
                                                            setEmailError("Email is required");
                                                        } else if (!validateEmail(formData.email)) {
                                                            setEmailError("Please enter a valid email address");
                                                        } else {
                                                            setEmailError("");
                                                        }
                                                    }
                                                }}
                                                style={{ flex: 1 }}
                                            >
                                                <option value="">Select Role</option>

                                                {allowedEmployeeRoles
                                                    .filter(role => {
                                                        if (pageName !== "StoreAdmin" && isStoreAdminRole(role)) {
                                                            return false;
                                                        }
                                                        // ❌ Hide ClusterManager if only ONE store selected
                                                        if (role === "ClusterManager" && selectedStoreCount === 1) {
                                                            return false;
                                                        }
                                                        return true;
                                                    })
                                                    .map(role => (
                                                        <option key={role} value={role}>
                                                            {role}
                                                        </option>
                                                    ))
                                                }

                                            </select>
                                            {dynamicRoles.some(r => r.roleName === formData.role) && (
                                                <Tooltip title={`Edit "${formData.role}" Role`}>
                                                    <div
                                                        onClick={() => handleOpenEditRoleModal(formData.role)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            padding: '8px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#eff6ff',
                                                            color: '#2563eb',
                                                            border: '1px solid #bfdbfe',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <Icon icon="mdi:pencil-outline" width={20} height={20} />
                                                    </div>
                                                </Tooltip>
                                            )}
                                            <Tooltip title="Add New Role">
                                                <div
                                                    onClick={handleOpenAddRoleModal}
                                                    style={{
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        padding: '8px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f1f5f9',
                                                        color: '#1e293b',
                                                        border: '1px solid #e2e8f0'
                                                    }}
                                                >
                                                    <Icon icon="mdi:plus" width={20} height={20} />
                                                </div>
                                            </Tooltip>
                                        </div>
                                        {errors.role && <p className="field-error">{errors.role}</p>}
                                    </div>


                                </div>
                                <div className="employee-form-row">

                                    <div className="employee-form-group">
                                        <label htmlFor="email" className="input-label">
                                            Email
                                            {rolesRequiringEmail.includes(formData.role) && (
                                                <span className="required">*</span>
                                            )}
                                        </label>
                                        <input
                                            type="email"
                                            className="category-input"
                                            placeholder={rolesRequiringEmail.includes(formData.role) ? "Enter Email" : "Enter Email (Optional)"}
                                            value={formData.email || ""}
                                            onChange={handleEmailChange}
                                            autoComplete="new-password"
                                        />
                                        {emailError && <p className="field-error">{emailError}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">
                                            Mobile Number
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Mobile Number (Optional)"
                                            // disabled={!formData.role}
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.phoneNumber}
                                            autoComplete="new-password"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                        // onBlur={() => {
                                        //     if (formData.phoneNumber.length !== 10) {
                                        //         alert("Mobile Number must be exactly 10 digits");
                                        //     }
                                        // }}
                                        />
                                        {errors.phoneNumber && <p className="field-error">{errors.phoneNumber}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="gender" className="input-label">
                                            Gender
                                            <span className="required">*</span>
                                        </label>
                                        <select
                                            id="gender"
                                            className="category-input"
                                            placeholder="Select Gender"
                                            // disabled={!formData.email}
                                            value={formData.gender}
                                            onChange={(e) => {
                                                const selectedgendertype = e.target.value;
                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                            }}
                                        >
                                            <option value='' >Select Gender</option>
                                            <option value='Male'>Male</option>
                                            <option value='Female'>Female</option>
                                            <option value='Other'>Other</option>
                                        </select>
                                        {errors.gender && <p className="field-error">{errors.gender}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="dateOfBirth" className="input-label">
                                            Date Of Birth
                                        </label>
                                        <input
                                            name="dateOfBirth"
                                            type="date"
                                            className="department-input"
                                            value={formData.dateOfBirth || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                const year = value?.split("-")[0] || "";

                                                if (year.length > 4) {
                                                    toast.error("Year should contain only 4 digits");
                                                    return;
                                                }

                                                const age = calculateAge(value);

                                                setFormData(prev => ({
                                                    ...prev,
                                                    dateOfBirth: value,
                                                    age
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                {isPasswordRequired && (
                                        <div className="employee-form-row">
                                            {/* Password */}
                                            <div className="employee-form-group">
                                                <label className="input-label">
                                                    Password <span className="required">*</span>
                                                </label>

                                                <div className="password-container" style={{ position: "relative" }}>
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        name="password"
                                                        placeholder="Password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        className="password-input"

                                                    />
                                                    {errors.password && <p className="field-error">{errors.password}</p>}

                                                    <div
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        className="password-show"
                                                        role="button"
                                                    >
                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Confirm Password */}
                                            <div className="employee-form-group">
                                                <label className="input-label">
                                                    Confirm Password <span className="required">*</span>
                                                </label>

                                                <div className="password-container" style={{ position: "relative" }}>
                                                    <input
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        name="confirmPassword"
                                                        placeholder="Confirm Password"
                                                        value={formData.confirmPassword}
                                                        onChange={handleChange}
                                                        className="password-input"
                                                    />
                                                    {errors.confirmPassword && <p className="field-error">{errors.confirmPassword}</p>}
                                                    <div
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        className="password-show"
                                                        role="button"
                                                    >
                                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                {["SuperAdmin", "SelfAdmin"].includes(loggedInRole) && (formData.role === "StoreManager" || formData.role === "Biller") && (
                                    <div className="employee-form-row">
                                        <div className="employee-form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                            <label className="input-label" style={{ marginBottom: 0 }}>Grant POS Access</label>
                                            <Switch
                                                checked={formData.hasPosAccess === true}
                                                onChange={(e) => setFormData(prev => ({ ...prev, hasPosAccess: e.target.checked }))}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: '#3C0008',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: '#3C0008',
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="dateOfJoining" className="input-label">
                                            Date of Joining <span className="required">*</span>
                                        </label>

                                        <input
                                            type="date"
                                            id="dateOfJoining"
                                            className="department-input"
                                            value={formData.dateOfJoining || ""}
                                            onChange={(e) => handleDateChange("dateOfJoining", e.target.value)}
                                        />

                                        {errors.dateOfJoining && (
                                            <p className="field-error">{errors.dateOfJoining}</p>
                                        )}
                                    </div>

                                    <div className="employee-form-group">
                                        <label htmlFor="dateOfResignation" className="input-label">
                                            Date of Resignation
                                        </label>

                                        <input
                                            type="date"
                                            id="dateOfResignation"
                                            className="department-input"
                                            value={formData.dateOfResignation || ""}
                                            onChange={(e) => handleDateChange("dateOfResignation", e.target.value)}
                                        />


                                    </div>

                                    <div className="employee-form-group">
                                        <label htmlFor="age" className="input-label">
                                            Age
                                        </label>
                                        <input
                                            type="number"
                                            className="department-input"
                                            value={formData.age || ""}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="bloodGroup" className="input-label">
                                            Blood Group
                                        </label>
                                        <input
                                            name="bloodGroup"
                                            placeholder="Enter Blood Group"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                                            }
                                            value={formData.bloodGroup}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProoftype" className="input-label">
                                            ID Proof Type
                                        </label>
                                        <select
                                            id="idProoftype"
                                            className="category-input"
                                            placeholder="Select id Proof type"
                                            // disabled={!formData.email}
                                            value={formData.idProoftype}
                                            onChange={(e) => {
                                                const selectedidProoftypetype = e.target.value;
                                                setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                                            }}
                                        >
                                            <option value='' >Select id Proof type</option>
                                            <option value='Voter ID'>VOTER ID</option>
                                            <option value='Aadhaar'>AADHAR</option>
                                            <option value='Driving License'>DRIVING LICENSE</option>
                                        </select>
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProofImage" className="input-label">
                                            ID Proof Image
                                        </label>
                                        <div className="id-proof-upload" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <input
                                                type="file"
                                                id="idProofImage"
                                                accept="image/*"
                                                className="category-input"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file && file.size > 1024 * 1024) {
                                                        toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                        e.target.value = "";
                                                        return;
                                                    }
                                                    if (file) {
                                                        setIdProofImage(file);
                                                        setIdPreviewUrl(URL.createObjectURL(file));
                                                    }
                                                }}
                                            />
                                            {IdPreviewUrl && (
                                                <div className="preview-container">
                                                    <img
                                                        src={IdPreviewUrl}
                                                        alt="ID Proof Preview"
                                                        style={{ width: '40px', height: '40px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                                                        onClick={() => window.open(IdPreviewUrl, '_blank')}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="refferedByName" className="input-label">
                                            Referer Name
                                        </label>
                                        <input
                                            name="refferedByName"
                                            placeholder="Enter referer name"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, refferedByName: e.target.value }))
                                            }
                                            value={formData.refferedByName}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="refferedByContactNumber" className="input-label">
                                            Referer Contact Number
                                        </label>
                                        <input
                                            name="refferedByContactNumber"
                                            placeholder="Enter referer contact number"
                                            type="text"
                                            className="department-input"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.refferedByContactNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, refferedByContactNumber: value }));
                                                }
                                            }}
                                        // onBlur={() => {
                                        //     if (formData.refferedByContactNumber.length !== 10) {
                                        //         alert("Mobile Number must be exactly 10 digits");
                                        //     }
                                        // }}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="emergencyContactPerson" className="input-label">
                                            Emergency Contact Person Name
                                        </label>
                                        <input
                                            name="emergencyContactPerson"
                                            placeholder="Enter emergency contact person name"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, emergencyContactPerson: e.target.value }))
                                            }
                                            value={formData.emergencyContactPerson}
                                        />
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="emergencyContactNumber" className="input-label">
                                            Emergency Contact Number
                                        </label>
                                        <input
                                            name="emergencyContactNumber"
                                            placeholder="Enter emergency contact number"
                                            type="text"
                                            className="department-input"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.emergencyContactNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, emergencyContactNumber: value }));
                                                }
                                            }}
                                        // onBlur={() => {
                                        //     if (formData.emergencyContactNumber.length !== 10) {
                                        //         alert("Mobile Number must be exactly 10 digits");
                                        //     }
                                        // }}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="currentAddress" className="input-label">
                                            Current Address
                                        </label>
                                        <input
                                            name="currentAddress"
                                            placeholder="Enter current address"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, currentAddress: e.target.value }))
                                            }
                                            value={formData.currentAddress}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="permanentAddress" className="input-label">
                                            Permanent Address
                                        </label>
                                        <input
                                            name="permanentAddress"
                                            placeholder="Enter permanent address"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, permanentAddress: e.target.value }))
                                            }
                                            value={formData.permanentAddress}
                                        />
                                    </div>
                                </div>
                                <div className="employee-buttons">
                                    <button className="add-Product-button" type="submit" disabled={emailError !== ""} onClick={isAddEmployee ? handleAddEmployee : handleUpdateEmployee}>
                                        {isEditMode ? "Update Employee" : "Add Employee"}
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/employees')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div >
                    ) : isStoreAdmin ? (
                        <div className="add-product-form">
                            <Typography variant="h6" textAlign="center" mb={4}>
                                {pageName === "StoreAdmin" ? "Add Store Admin" : "Add Employee"}
                            </Typography>
                            <form className="employee-form" onSubmit={handleAddEmployee}>
                                <div className="employee-form-row">
                                    <div className="employee-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="employeeImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="employeeImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.size > 1024 * 1024) {
                                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                            e.target.value = "";
                                                            return;
                                                        }
                                                        setEmployeeImage(file);
                                                        setPreviewUrl(URL.createObjectURL(file));
                                                    }}
                                                />

                                            </label>

                                        </div>
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="name" className="input-label">
                                            Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter employee name"
                                            className="category-input"
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                        {errors.name && <p className="field-error">{errors.name}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="email" className="input-label">
                                            Email
                                            <span className="required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="category-input"
                                            placeholder={rolesRequiringEmail.includes(formData.role) ? "Enter Email" : "Enter Email (Optional)"}
                                            value={formData.email || ""}
                                            onChange={handleEmailChange}
                                            autoComplete="new-password"
                                        />
                                        {errors.email && <p className="field-error">{errors.email}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">
                                            Mobile Number
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Mobile Number (Optional)"
                                            // disabled={!formData.role}
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.phoneNumber}
                                            autoComplete="new-password"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                        // onBlur={() => {
                                        //     if (formData.phoneNumber.length !== 10) {
                                        //         alert("Mobile Number must be exactly 10 digits");
                                        //     }
                                        // }}
                                        />
                                        {errors.phoneNumber && <p className="field-error">{errors.phoneNumber}</p>}
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label className="input-label">Stores</label>

                                        <StoreMultiSelect
                                            value={selectedStores}
                                            onChange={(val) => {
                                                setSelectedStores(val);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeIds: val.map(v => v.value)
                                                }));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={loggedInRole}
                                            assignedStoreIds={adminStoreIds}
                                            onAddStore={() => setIsAddStore(true)}
                                        />
                                        {selectedStores.length === 0 && (
                                            <p className="field-error">{errors.storeIds}</p>
                                        )}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="role" className="input-label">
                                            Role
                                        </label>
                                        <input type="text" className="category-input" value={formData.role} disabled />
                                        {errors.role && <p className="field-error">{errors.role}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="gender" className="input-label">
                                            Gender
                                        </label>
                                        <select
                                            id="gender"
                                            className="category-input"
                                            placeholder="Select Gender"
                                            // disabled={!formData.email}
                                            value={formData.gender}
                                            onChange={(e) => {
                                                const selectedgendertype = e.target.value;
                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                            }}
                                        >
                                            <option value='' >Select Gender</option>
                                            <option value='Male'>Male</option>
                                            <option value='Female'>Female</option>
                                            <option value='Other'>Other</option>
                                        </select>
                                        {errors.gender && <p className="field-error">{errors.gender}</p>}
                                    </div>
                                </div>
                                {isPasswordRequired && (
                                    <div className="employee-form-row">
                                        {/* Password */}
                                        <div className="employee-form-group">
                                            <label className="input-label">
                                                Password <span className="required">*</span>
                                            </label>

                                            <div className="password-container" style={{ position: "relative" }}>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    placeholder="Password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    className="password-input"

                                                />
                                                {errors.password && <p className="field-error">{errors.password}</p>}

                                                <div
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    className="password-show"
                                                    role="button"
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>

                                        </div>

                                        {/* Confirm Password */}
                                        <div className="employee-form-group">
                                            <label className="input-label">
                                                Confirm Password <span className="required">*</span>
                                            </label>

                                            <div className="password-container" style={{ position: "relative" }}>
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    name="confirmPassword"
                                                    placeholder="Confirm Password"
                                                    value={formData.confirmPassword}
                                                    onChange={handleChange}
                                                    className="password-input"
                                                />
                                                {errors.confirmPassword && <p className="field-error">{errors.confirmPassword}</p>}
                                                <div
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    className="password-show"
                                                    role="button"
                                                >
                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="employee-form-group">
                                            <label htmlFor="dateOfJoining" className="input-label">
                                                Date of Joining
                                                <span className="required">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                id="dateOfJoining"
                                                className="department-input"
                                                value={formData.dateOfJoining || ""}
                                                onChange={(e) => handleDateChange("dateOfJoining", e.target.value)}
                                            />

                                            {errors.dateOfJoining && <p className="field-error">{errors.dateOfJoining}</p>}
                                        </div>
                                    </div>
                                )}
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="bloodGroup" className="input-label">
                                            Blood Group
                                        </label>
                                        <input
                                            name="bloodGroup"
                                            placeholder="Enter Blood Group"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                                            }
                                            value={formData.bloodGroup}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProoftype" className="input-label">
                                            ID Proof Type
                                        </label>
                                        <select
                                            id="idProoftype"
                                            className="category-input"
                                            placeholder="Select id Proof type"
                                            // disabled={!formData.email}
                                            value={formData.idProoftype}
                                            onChange={(e) => {
                                                const selectedidProoftypetype = e.target.value;
                                                setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                                            }}
                                        >
                                            <option value='' >Select id Proof type</option>
                                            <option value='Voter ID'>VOTER ID</option>
                                            <option value='Aadhaar'>AADHAR</option>
                                            <option value='Driving License'>DRIVING LICENSE</option>
                                        </select>
                                        {/* {errors.idProoftype && <p className="field-error">{errors.idProoftype}</p>} */}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProofImage" className="input-label">
                                            ID Proof Image
                                        </label>
                                        <div className="id-proof-upload" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <input
                                                type="file"
                                                id="idProofImage"
                                                accept="image/*"
                                                className="category-input"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file && file.size > 1024 * 1024) {
                                                        toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                        e.target.value = "";
                                                        return;
                                                    }
                                                    if (file) {
                                                        setIdProofImage(file);
                                                        setIdPreviewUrl(URL.createObjectURL(file));
                                                    }
                                                }}
                                            />
                                            {IdPreviewUrl && (
                                                <div className="preview-container">
                                                    <img
                                                        src={IdPreviewUrl}
                                                        alt="ID Proof Preview"
                                                        style={{ width: '40px', height: '40px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                                                        onClick={() => window.open(IdPreviewUrl, '_blank')}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="employee-buttons">
                                    <button className="add-Product-button" type="submit" disabled={emailError !== ""} onClick={isAddEmployee || isStoreAdmin ? handleAddEmployee : handleUpdateEmployee}>
                                        {isEditMode ? "Update Store Admin" : "Add Store Admin"}
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate(isStoreAdmin ? "/store-admin" : "/users")}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div >
                    ) :
                        (
                            <>
                                <Typography variant="h6" mb={2}>
                                    {pageName === "StoreAdmin" ? "Store Admin" : "Employees"}
                                </Typography>
                                <div className="product-widgets">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder={pageName === "StoreAdmin" ? "Search Store Admins..." : "Search Employees..."}
                                            className="employee-search-input"
                                            name="search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Icon icon="mdi:magnify" className="search-icon" />
                                    </div>
                                    {(loggedInRole === "SuperAdmin" || loggedInRole === "SelfAdmin") && (
                                        <StoreSingleAllStoresSelect
                                            value={store}
                                            onChange={
                                                (store) => {
                                                    setStore(store)
                                                }
                                            }
                                        />
                                    )}
                                    <div className="employee-actions">
                                        <button className="add-Product-button" onClick={() => navigate(
                                            pageName === 'StoreAdmin' ? '/store-admin/add' : '/employees/add'
                                        )}>
                                            {pageName === 'StoreAdmin' ? '+ Add Store Admin' : '+ Add Employee'}
                                        </button>
                                    </div>
                                </div>
                                <Box component={Paper}>
                                    <TableContainer sx={{
                                        maxHeight: 400,
                                        overflowY: "auto",
                                        '&::-webkit-scrollbar': { display: 'none' },
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none',
                                    }}>
                                        <Table className="custom-employee-table">
                                            <TableHead className="custom-product-head">
                                                <TableRow>
                                                    {headings.map((heading, index) => {
                                                        const isName = heading === "Name";
                                                        const isEmail = heading === "Email";
                                                        const isPhoneNumber = heading === "Phone Number";
                                                        const isRole = heading === "Role"
                                                        const isStaffId = heading === "StaffId";
                                                        const sortKey = isName
                                                            ? "name"
                                                            : isEmail
                                                                ? "email"
                                                                : isPhoneNumber
                                                                    ? "phoneNumber"
                                                                    : isRole
                                                                        ? "role"
                                                                        : null

                                                        return (
                                                            <TableCell
                                                                key={index}
                                                                className={isStaffId ? "staff-id-column" : ""}
                                                                sx={{
                                                                    border: "none",
                                                                    padding: "12px 16px",
                                                                    textAlign: "center",
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    zIndex: 10,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "4px",
                                                                        color: "#ffffff",
                                                                        fontSize: "14px",
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {heading}

                                                                    {sortKey && (
                                                                        <span
                                                                            onClick={() => handleSort(sortKey)}
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                color: "#ffffffff",
                                                                                cursor: "pointer",
                                                                                marginLeft: "4px",
                                                                                userSelect: "none",
                                                                            }}
                                                                        >
                                                                            {sortField === sortKey
                                                                                ? sortOrder === 1
                                                                                    ? "▲"
                                                                                    : "▼"
                                                                                : "▲▼"}
                                                                        </span>
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {users.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={5}>
                                                            <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                                No {pageName === "StoreAdmin" ? "Store Admins" : "Employees"} found.
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    users.map((user, index) => (
                                                        <TableRow key={user._id}>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <img
                                                                        src={
                                                                            user.employeeImageObject?.uri
                                                                                ? `${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`
                                                                                : "/assets/management-consulting.png"
                                                                        }
                                                                        alt={user.name}
                                                                        style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                                                                    />
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell><Typography sx={commonCellStyle}>{user.name || user.firstName}</Typography></TableCell>
                                                            <TableCell><Typography sx={commonCellStyle}>{user.email}</Typography></TableCell>
                                                            <TableCell><Typography sx={commonCellStyle}>{user.phoneNumber}</Typography></TableCell>
                                                            <TableCell><Typography sx={commonCellStyle}>{user.role}</Typography></TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {user.store?.map(s => s.storeName).join(", ")}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell className="staff-id-column">
                                                                <Typography sx={commonCellStyle}>
                                                                    {user.staffId}
                                                                </Typography>
                                                            </TableCell>
                                                            {["SuperAdmin", "SelfAdmin"].includes(loggedInRole) && (
                                                                <TableCell>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        {(user.role === "StoreManager" || user.role === "Biller" || user.role === "StoreAdmin") ? (
                                                                            <Switch
                                                                                checked={user.hasPosAccess === true}
                                                                                onChange={(e) => handleTogglePosAccess(user, e.target.checked)}
                                                                                sx={{
                                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                                        color: '#3C0008',
                                                                                    },
                                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                                        backgroundColor: '#3C0008',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Typography sx={{ color: '#94a3b8', fontSize: '11px', fontWeight: 700 }}>N/A</Typography>
                                                                        )}
                                                                    </Box>
                                                                </TableCell>
                                                            )}
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Switch
                                                                        checked={user.isActive !== false}
                                                                        onChange={(e) => handleToggleStatus(user, e.target.checked)}
                                                                        sx={{
                                                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                                                color: '#3C0008',
                                                                            },
                                                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                                backgroundColor: '#3C0008',
                                                                            },
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </TableCell>
                                                            {/* <TableCell>
                                                            <Typography sx={commonCellStyle}>{user.todayAttendance}</Typography>
                                                        </TableCell> */}
                                                            <TableCell>

                                                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Tooltip title={pageName === "StoreAdmin" ? "View Store Admin" : "View Employee"}>
                                                                        <Icon
                                                                            icon={plusIcon}
                                                                            width={20}
                                                                            height={20}
                                                                            style={{ cursor: "pointer", color: "#1a1e27" }}
                                                                            onClick={() => handleViewEmployee(user._id)}
                                                                        />
                                                                    </Tooltip>
                                                                    {loggedInRole !== user.role && (
                                                                        <Tooltip title={pageName === "StoreAdmin" ? "Edit Store Admin" : "Edit Employee"}>
                                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    const formatDateOnly = (dateStr) => {
                                                                                        if (!dateStr) return "";
                                                                                        return new Date(dateStr).toISOString().slice(0, 10);
                                                                                    };
                                                                                    // 1️⃣ FORM DATA
                                                                                    const selectedStoreOptions = (user.store || []).map(s => ({
                                                                                        label: s.storeName || s.branchName || '',
                                                                                        value: s._id || s
                                                                                    }));
                                                                                    setSelectedStores(selectedStoreOptions);
                                                                                    setFormData({
                                                                                        name: user.name || '',
                                                                                        email: user.email || '',
                                                                                        role: user.role || '',
                                                                                        phoneNumber: user.phoneNumber || '',
                                                                                        gender: user.gender || '',
                                                                                        employeeImageObject: user.employeeImageObject || '',
                                                                                        staffId: user.staffId || '',
                                                                                        dateOfBirth: formatDateOnly(user.dateOfBirth),
                                                                                        dateOfJoining: formatDateOnly(user.dateOfJoining),
                                                                                        dateOfResignation: formatDateOnly(user.dateOfResignation),
                                                                                        age: user.age || '',
                                                                                        currentAddress: user.currentAddress || '',
                                                                                        permanentAddress: user.permanentAddress || '',
                                                                                        bloodGroup: user.bloodGroup || '',
                                                                                        emergencyContactPerson: user.emergencyContactPerson || '',
                                                                                        emergencyContactNumber: user.emergencyContactNumber || '',
                                                                                        idProoftype: user.idProoftype || '',
                                                                                        storeIds: user.storeIds || (user.store || []).map(s => s._id || s),
                                                                                        idProofImageObject: user.idProofImageObject || '',
                                                                                        refferedByName: user.refferedByName || '',
                                                                                        refferedByContactNumber: user.refferedByContactNumber || '',
                                                                                        isActive: user.isActive !== undefined ? user.isActive : true,
                                                                                        hasPosAccess: user.hasPosAccess === true,
                                                                                        password: '',
                                                                                        confirmPassword: ''
                                                                                    });
                                                                                    // 3️⃣ OTHER UI SETTINGS
                                                                                    setPreviewUrl(
                                                                                        user?.employeeImageObject?.uri
                                                                                            ? `${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`
                                                                                            : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                                    );
                                                                                    setIdPreviewUrl(
                                                                                        user?.idProofImageObject?.uri
                                                                                            ? `${process.env.REACT_APP_API_URL}${user.idProofImageObject.uri}`
                                                                                            : ""
                                                                                    );
                                                                                    setEmployeeImage(null);
                                                                                    setIdProofImage(null);
                                                                                    setEditEmployeeId(user._id);
                                                                                    setOriginalEditRole(user.role || "");
                                                                                    setIsPopupMode(true);
                                                                                    setIsEditMode(true);
                                                                                    setLoaderText("Updating Employee...");
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                    {loggedInRole !== "SelfAdmin" &&
                                                                        loggedInRole !== "StoreCreator" &&
                                                                        loggedInRole !== user.role &&
                                                                        user.isActive !== false && (
                                                                            <Tooltip title={pageName === "StoreAdmin" ? "Delete Store Admin" : "Delete Employee"}>
                                                                                <Icon
                                                                                    icon={deleteIcon}
                                                                                    width={20}
                                                                                    height={20}
                                                                                    style={{ color: '#C10000', cursor: 'pointer' }}
                                                                                    onClick={() => handleOpen(user._id)}
                                                                                />
                                                                            </Tooltip>
                                                                        )}

                                                                </Box>

                                                            </TableCell>
                                                        </TableRow>

                                                    ))
                                                )}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <div className="product-bottom">
                                        <div className="product-section show-entries">
                                            <span className="text-label">Show</span>
                                            <select className="entries-select" value={limit}
                                                onChange={handleItemsPerPageChange}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="all">All</option>
                                            </select>
                                            <span className="text-label">Entries</span>
                                        </div>
                                        <div className="product-section showing-range">
                                            {
                                                limit === 'all'
                                                    ? `Showing all ${totalCount} entries`
                                                    : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                            }
                                        </div>
                                        <div className="product-section spacer"></div>
                                        <div className="product-section pagination-buttons">
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("first")}
                                            ><Icon icon="mdi:chevron-double-left" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("prev")}
                                            ><Icon icon="mdi:chevron-left" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("next")}
                                            ><Icon icon="mdi:chevron-right" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("last")}
                                            ><Icon icon="mdi:chevron-double-right" /></button>
                                        </div>
                                    </div>
                                </Box>
                                {isPopupMode && (
                                    <div className="popup-overlay">
                                        <div className="user-popup-wrapper">
                                            <Icon
                                                icon={closeIcon}
                                                className="popup-close-icon-outside"
                                                onClick={() => {
                                                    setIsPopupMode(false);
                                                    setIsEditMode(false);
                                                    setFormData({
                                                        name: '',
                                                        email: '',
                                                        role: '',
                                                        phoneNumber: '',
                                                        departmentId: '',
                                                        storeId: '',
                                                        employeeImageObject: null,
                                                        staffId: '',
                                                        password: '',
                                                        confirmPassword: '',
                                                        age: '',
                                                        dateOfBirth: '',
                                                        dateOfJoining: '',
                                                        dateOfResignation: '',
                                                        currentAddress: '',
                                                        permanentAddress: '',
                                                        bloodGroup: '',
                                                        emergencyContactPerson: '',
                                                        emergencyContactNumber: '',
                                                        idProoftype: '',
                                                        idProofImageObject: '',
                                                        refferedByName: '',
                                                        refferedByContactNumber: ''
                                                    });
                                                    setPreviewUrl(null);
                                                    setIdPreviewUrl(null);
                                                    setIdProofImage(null);
                                                    setLoaderText('');
                                                }}
                                            />

                                            <div className="popup-form-Employee">
                                                <Typography variant="h6" textAlign="center" mb={4}>
                                                    {pageName === "StoreAdmin"
                                                        ? (isEditMode ? "Edit Store Admin" : "Add Store Admin")
                                                        : (isEditMode ? "Edit Employee" : "Add Employee")}
                                                </Typography>
                                                <form className="popup-form-body" onSubmit={handleUpdateEmployee}>
                                                    <div className="form-group-row">
                                                        <div className="employee-form-group-image">
                                                            <div className="image-upload-wrapper">
                                                                <div className="image-placeholder">
                                                                    <img
                                                                        src={previewUrl || '/assets/mdi--user.svg'}
                                                                        alt="Preview"
                                                                        className="round-image"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="upload-icon-container">
                                                                <label htmlFor="employeeImage" className="upload-icon-btn">
                                                                    Upload Image
                                                                    <Icon icon={trayUpload} width="24" height="24" />
                                                                    <input
                                                                        type="file"
                                                                        id="employeeImage"
                                                                        accept="image/*"
                                                                        style={{ display: 'none' }}
                                                                        onChange={(e) => {
                                                                            const file = e.target.files[0];
                                                                            if (file && file.size > 1024 * 1024) {
                                                                                toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                                                e.target.value = "";
                                                                                return;
                                                                            }
                                                                            setEmployeeImage(file);
                                                                            setPreviewUrl(URL.createObjectURL(file));
                                                                        }}
                                                                    />

                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="name" className="input-label">
                                                                Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter employee name"
                                                                className="category-input"
                                                                value={formData.name}
                                                                onChange={e =>
                                                                    setFormData(prev => ({ ...prev, name: e.target.value }))
                                                                }
                                                            />
                                                        </div>
                                                        {
                                                            isAddEmployee ? (<div className="form-group">
                                                                <label htmlFor="role" className="input-label">
                                                                    Role
                                                                </label>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <select
                                                                        id="role"
                                                                        className="category-input"
                                                                        // disabled={!formData.name}
                                                                        value={formData.role}
                                                                        onChange={(e) => {
                                                                            const selectedRole = e.target.value;
                                                                            if (pageName !== "StoreAdmin" && isStoreAdminRole(selectedRole)) {
                                                                                toast.error("Store Admin role cannot be assigned to an employee.");
                                                                                return;
                                                                            }
                                                                            setFormData((prev) => ({ ...prev, role: selectedRole }))
                                                                        }}
                                                                        style={{ flex: 1 }}
                                                                    >
                                                                        <option value="" disabled>Select Role</option>
                                                                        {allowedEmployeeRoles
                                                                            .filter(role => {
                                                                                if (pageName !== "StoreAdmin" && isStoreAdminRole(role)) {
                                                                                    return false;
                                                                                }
                                                                                if (role === "ClusterManager" && selectedStoreCount === 1) {
                                                                                    return false;
                                                                                }
                                                                                return true;
                                                                            })
                                                                            .map((role) => (
                                                                                <option key={role} value={role}>
                                                                                    {role}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                    {dynamicRoles.some(r => r.roleName === formData.role) && (
                                                                        <Tooltip title={`Edit "${formData.role}" Role`}>
                                                                            <div
                                                                                onClick={() => handleOpenEditRoleModal(formData.role)}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    display: 'flex',
                                                                                    padding: '8px',
                                                                                    borderRadius: '8px',
                                                                                    backgroundColor: '#eff6ff',
                                                                                    color: '#2563eb',
                                                                                    border: '1px solid #bfdbfe',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}
                                                                            >
                                                                                <Icon icon="mdi:pencil-outline" width={20} height={20} />
                                                                            </div>
                                                                        </Tooltip>
                                                                    )}
                                                                    <Tooltip title="Add New Role">
                                                                        <div
                                                                            onClick={handleOpenAddRoleModal}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                display: 'flex',
                                                                                padding: '8px',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#f1f5f9',
                                                                                color: '#1e293b',
                                                                                border: '1px solid #e2e8f0'
                                                                            }}
                                                                        >
                                                                            <Icon icon="mdi:plus" width={20} height={20} />
                                                                        </div>
                                                                    </Tooltip>
                                                                </div>
                                                                {errors.role && <p className="field-error">{errors.role}</p>}
                                                            </div>) : (
                                                                <div className="form-group">
                                                                    <label htmlFor="role" className="input-label">
                                                                        Role
                                                                    </label>
                                                                    <select
                                                                        id="role"
                                                                        className="category-input"
                                                                        value={formData.role || ""}
                                                                        onChange={(e) => {
                                                                            const selectedRole = e.target.value;
                                                                            if (pageName !== "StoreAdmin" && isStoreAdminRole(selectedRole)) {
                                                                                toast.error("Store Admin role cannot be assigned to an employee.");
                                                                                return;
                                                                            }
                                                                            const isPwdReq = pageName === "StoreAdmin" || ["StoreManager", "Biller"].includes(selectedRole);
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                role: selectedRole,
                                                                                ...(!isPwdReq ? { password: '', confirmPassword: '' } : {})
                                                                            }));
                                                                        }}
                                                                    >
                                                                        <option value="" disabled>Select Role</option>
                                                                        {[
                                                                            // Keep the employee's current role visible even if it isn't assignable by this user
                                                                            ...(originalEditRole && !allowedEmployeeRoles.includes(originalEditRole) ? [originalEditRole] : []),
                                                                            ...allowedEmployeeRoles.filter(role => {
                                                                                if (pageName !== "StoreAdmin" && isStoreAdminRole(role)) {
                                                                                    return false;
                                                                                }
                                                                                if (role === "ClusterManager" && selectedStoreCount === 1 && role !== originalEditRole) {
                                                                                    return false;
                                                                                }
                                                                                return true;
                                                                            })
                                                                        ].map((role) => (
                                                                            <option key={role} value={role}>
                                                                                {role}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            )
                                                        }
                                                        <div className="form-group">
                                                            <label htmlFor="phoneNumber" className="input-label">Mobile Number</label>
                                                            <input
                                                                type="text"
                                                                className="category-input"
                                                                placeholder="Enter Mobile Number (Optional)"
                                                                // disabled={!formData.role}
                                                                maxLength={12}
                                                                title="Mobile Number must be exactly 12 digits"
                                                                value={formData.phoneNumber}
                                                                autoComplete="new-password"
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    // Allow only digits and max 12 characters
                                                                    if (/^\d{0,10}$/.test(value)) {
                                                                        setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                                    }
                                                                }}
                                                            // onBlur={() => {
                                                            //     if (formData.phoneNumber.length !== 10) {
                                                            //         alert("Mobile Number must be exactly 10 digits");
                                                            //     }
                                                            // }}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="email" className="input-label">
                                                                Email
                                                            </label>
                                                            <input
                                                                type="email"
                                                                className="category-input"
                                                                placeholder="Enter Email"
                                                                // disabled={!formData.phoneNumber}
                                                                value={formData.email || ""}
                                                                onChange={handleEmailChange}
                                                                autoComplete="new-password"
                                                            />
                                                            {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="dateOfBirth" className="input-label">
                                                                Date-Of-Birth
                                                            </label>
                                                            <input
                                                                name="dateOfBirth"
                                                                type="date"
                                                                className="department-input"
                                                                value={formData.dateOfBirth || ""}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    const year = value?.split("-")[0] || "";

                                                                    if (year.length > 4) {
                                                                        toast.error("Year should contain only 4 digits");
                                                                        return;
                                                                    }

                                                                    const age = calculateAge(value);

                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        dateOfBirth: value,
                                                                        age
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="gender" className="input-label">
                                                                Gender
                                                            </label>
                                                            <select
                                                                id="gender"
                                                                className="category-input"
                                                                placeholder="Select Gender"

                                                                value={formData.gender}
                                                                onChange={(e) => {
                                                                    const selectedgendertype = e.target.value;
                                                                    setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                                                }}
                                                            >
                                                                <option value='' >Select Gender</option>
                                                                <option value='Male'>Male</option>
                                                                <option value='Female'>Female</option>
                                                                <option value='Other'>Other</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="StaffId" className="input-label">
                                                                Staff ID
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="staffId"
                                                                placeholder="Staff ID"

                                                                onChange={e =>
                                                                    setFormData(prev => ({ ...prev, staffId: e.target.value }))
                                                                }
                                                                value={formData.staffId}
                                                                className="department-input"
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="input-label">Stores</label>
                                                            <StoreMultiSelect
                                                                value={selectedStores}
                                                                onChange={(val) => {
                                                                    setSelectedStores(val);
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        storeIds: val.map(v => v.value)
                                                                    }));
                                                                }}
                                                                loadStores={loadStores}
                                                                loggedInRole={loggedInRole}
                                                                assignedStoreIds={adminStoreIds}
                                                                onAddStore={() => setIsAddStore(true)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {!["Stylist", "Beautician", "SeniorStylist"].includes(formData.role) && (
                                                        <div className="form-group-row">
                                                            <div className="form-group">
                                                                <label htmlFor="password" className="input-label">
                                                                    Password
                                                                </label>
                                                                <input
                                                                    type={showPassword ? "text" : "password"}
                                                                    name="password"
                                                                    placeholder="Password"
                                                                    value={formData.password || ""}
                                                                    onChange={handleChange}
                                                                    className="department-input"
                                                                    autoComplete="new-password"
                                                                />
                                                                <span
                                                                    className="employee-signup-show"
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                >
                                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </span>
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="confirmPassword" className="input-label">
                                                                    Confirm Password
                                                                </label>
                                                                <input
                                                                    type={showConfirmPassword ? "text" : "password"}
                                                                    name="confirmPassword"
                                                                    placeholder="Confirm Password"
                                                                    value={formData.confirmPassword || ""}
                                                                    onChange={handleChange}
                                                                    className="department-input"
                                                                    autoComplete="new-password"
                                                                />
                                                                <span
                                                                    className="employee-signup-show"
                                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                                >
                                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </span>

                                                                {passwordMatchError && (
                                                                    <p className="password-error-text">{passwordMatchError}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="dateOfJoining" className="input-label">
                                                                Date-Of-Joining
                                                            </label>
                                                            <input
                                                                type="date"
                                                                id="dateOfJoining"
                                                                className="department-input"
                                                                value={formData.dateOfJoining || ""}
                                                                onChange={(e) =>
                                                                    handleDateChange("dateOfJoining", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="dateOfResignation" className="input-label">
                                                                Date-Of-Resignation
                                                            </label>
                                                            <input
                                                                name="dateOfResignation"
                                                                placeholder="enter Date Of Resignation"
                                                                type="date"
                                                                className="department-input"
                                                                value={formatDateTime(formData.dateOfResignation)}
                                                                onChange={(e) =>
                                                                    handleDateChange("dateOfResignation", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="age" className="input-label">
                                                                Age
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="department-input"
                                                                value={formData.age || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="bloodGroup" className="input-label">
                                                                Blood Group
                                                            </label>
                                                            <input
                                                                name="bloodGroup"
                                                                placeholder="Enter Blood Group"
                                                                type="text"
                                                                className="department-input"
                                                                onChange={e =>
                                                                    setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                                                                }
                                                                value={formData.bloodGroup}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="idProoftype" className="input-label">
                                                                ID Proof Type
                                                            </label>
                                                            <select
                                                                id="idProoftype"
                                                                className="category-input"
                                                                placeholder="Select id Proof type"
                                                                // disabled={!formData.email}
                                                                value={formData.idProoftype}
                                                                onChange={(e) => {
                                                                    const selectedidProoftypetype = e.target.value;
                                                                    setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                                                                }}
                                                            >
                                                                <option value='' >Select id Proof type</option>
                                                                <option value='Ration Card'>Ration Card</option>
                                                                <option value='Voter ID'>Voter ID</option>
                                                                <option value='Aadhaar'>Aadhaar</option>
                                                                <option value='PAN CARD'>PAN CARD</option>
                                                                <option value='Passport'>PASSPORT</option>
                                                                <option value='Driving License'>DRIVING LICENSE</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="idProofImage" className="input-label">
                                                                ID Proof Image
                                                            </label>
                                                            <div className="id-proof-upload" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                                <input
                                                                    type="file"
                                                                    id="idProofImage"
                                                                    accept="image/*"
                                                                    className="category-input"
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file && file.size > 1024 * 1024) {
                                                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                                                            e.target.value = "";
                                                                            return;
                                                                        }
                                                                        if (file) {
                                                                            setIdProofImage(file);
                                                                            setIdPreviewUrl(URL.createObjectURL(file));
                                                                        }
                                                                    }}
                                                                />
                                                                {IdPreviewUrl && (
                                                                    <div className="preview-container">
                                                                        <img
                                                                            src={IdPreviewUrl}
                                                                            alt="ID Proof Preview"
                                                                            style={{ width: '40px', height: '40px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                                                                            onClick={() => window.open(IdPreviewUrl, '_blank')}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-actions">
                                                        <button type="submit" className="add-Product-button">
                                                            {pageName === "StoreAdmin"
                                                                ? (isEditMode ? "Update Store Admin" : "Add Store Admin")
                                                                : (isEditMode ? "Update Employee" : "Add Employee")}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="cancel-Product-button"
                                                            onClick={() => setIsPopupMode(false)}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                >
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: 380,
                                            background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                            borderRadius: "20px",
                                            boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                            p: 4,
                                            outline: "none",
                                            textAlign: "center",
                                            overflow: "hidden"
                                        }}
                                    >
                                        {/* ✅ TOP ICON BADGE */}
                                        <Box
                                            sx={{
                                                width: 74,
                                                height: 74,
                                                borderRadius: "50%",
                                                background: "#3C0008",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto 16px auto",
                                                color: "#fff",
                                                fontSize: 30,

                                                boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                                animation: "deletePulse 1.6s infinite ease-in-out",

                                                "@keyframes deletePulse": {
                                                    "0%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                    },
                                                    "70%": {
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                    },
                                                    "100%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                    },
                                                },
                                            }}
                                        >
                                            🗑️
                                        </Box>


                                        {/* ✅ TITLE */}
                                        <Typography
                                            id="modal-modal-title"
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                color: "#2b2b2b",
                                                letterSpacing: "0.3px"
                                            }}
                                        >
                                            Confirm Delete
                                        </Typography>

                                        {/* ✅ DESCRIPTION */}
                                        <Typography
                                            id="modal-modal-description"
                                            sx={{
                                                mt: 1.2,
                                                fontSize: 14,
                                                color: "#666",
                                                lineHeight: 1.6
                                            }}
                                        >
                                            Are you sure you want to delete this {pageName === "StoreAdmin" ? "store admin" : "employee"}?
                                        </Typography>

                                        {/* ✅ BUTTON GROUP */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: 2.5,
                                                mt: 3.5
                                            }}
                                        >
                                            {/* ✅ DELETE BUTTON */}
                                            <Button
                                                variant="contained"
                                                onClick={handleDeleteEmployee}
                                                className="add-Product-button"
                                            >
                                                Yes, Delete
                                            </Button>

                                            {/* ✅ CANCEL BUTTON */}
                                            <Button
                                                variant="outlined"
                                                onClick={handleClose}
                                                className="cancel-Product-button"
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>
                                {isViewEmployeePopup && viewEmployeeData && (
                                    <Modal
                                        open={isViewEmployeePopup}
                                        onClose={() => setIsViewEmployeePopup(false)}
                                        closeAfterTransition
                                    >
                                        <Box sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: { xs: '95%', sm: '80%', md: 750 },
                                            maxHeight: '85vh',
                                            bgcolor: '#ffffff',
                                            borderRadius: '24px',
                                            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                                            overflow: 'hidden',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            outline: 'none',
                                            animation: 'modalSlideUp 0.4s ease-out',
                                            '@keyframes modalSlideUp': {
                                                '0%': { transform: 'translate(-50%, -40%)', opacity: 0 },
                                                '100%': { transform: 'translate(-50%, -50%)', opacity: 1 }
                                            }
                                        }}>
                                            {/* Top Banner & Profile Header */}
                                            <Box sx={{
                                                height: '140px',
                                                background: 'linear-gradient(135deg, #3C0008 0%, #3C0008 100%)',
                                                position: 'relative',
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                px: 4,
                                                pb: 2
                                            }}>
                                                <IconButton
                                                    onClick={() => setIsViewEmployeePopup(false)}
                                                    sx={{ position: 'absolute', top: 16, right: 16, color: 'white', '&:hover': { background: '#3C0008' } }}
                                                >
                                                    <Icon icon={closeIcon} />
                                                </IconButton>

                                                <Box sx={{
                                                    position: 'absolute',
                                                    bottom: '-50px',
                                                    left: '40px',
                                                    width: '120px',
                                                    height: '120px',
                                                    borderRadius: '24px',
                                                    border: '4px solid #ffffff',
                                                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                                                    overflow: 'hidden',
                                                    bgcolor: '#f8f9fa'
                                                }}>
                                                    <img
                                                        src={viewEmployeeData.employeeImageObject?.uri
                                                            ? `${process.env.REACT_APP_API_URL}${viewEmployeeData.employeeImageObject.uri}`
                                                            : "/assets/management-consulting.png"
                                                        }
                                                        alt={viewEmployeeData.name}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />
                                                </Box>

                                                <Box sx={{ ml: '140px', mb: 1 }}>
                                                    <Typography variant="h5" sx={{ color: 'white', fontWeight: 700, mb: 0.5 }}>
                                                        {viewEmployeeData.name || viewEmployeeData.firstName}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Chip
                                                            label={viewEmployeeData.role}
                                                            size="small"
                                                            sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontWeight: 600, fontSize: '12px' }}
                                                        />
                                                        <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgba(255,255,255,0.7)', gap: 0.5 }}>
                                                            <Icon icon="mdi:circle" style={{ fontSize: '8px', color: viewEmployeeData.isActive ? '#4CAF50' : '#DC3545' }} />
                                                            <Typography variant="caption" fontWeight={600}>
                                                                {viewEmployeeData.isActive ? 'Active' : 'Inactive'}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            {/* Modal Content */}
                                            <Box sx={{ mt: '60px', p: 4, overflowY: 'auto', flex: 1, bgcolor: '#f8fafc' }}>

                                                {/* Grid Layout Sections */}
                                                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4 }}>

                                                    {/* Section 1: Basic Information */}
                                                    <Box>
                                                        <SectionHeader icon="mdi:account-details" title="Personal Profile" color="#3C0008" />
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, bgcolor: '#ffffff', p: 2, borderRadius: '16px' }}>
                                                            <DetailItem label="Staff ID" value={viewEmployeeData.staffId} icon="mdi:card-account-details-outline" fullWidth color="#3C0008" />
                                                            <DetailItem label="Gender" value={viewEmployeeData.gender} icon="mdi:gender-male-female" color="#3C0008" />
                                                            <DetailItem label="Age" value={viewEmployeeData.age} icon="mdi:calendar-account" color="#3C0008" />
                                                            <DetailItem label="Blood Group" value={viewEmployeeData.bloodGroup} icon="mdi:water" color="#3C0008" />
                                                            <DetailItem label="DOB" value={viewEmployeeData.dateOfBirth ? dayjs(viewEmployeeData.dateOfBirth).format("DD/MM/YYYY") : "-"} icon="mdi:cake-variant" color="#3C0008" />
                                                            <DetailItem label="ID Type" value={viewEmployeeData.idProoftype || "-"} icon="mdi:card-text-outline" color="#3C0008" />
                                                            <DetailItem
                                                                label="ID Proof"
                                                                value={
                                                                    viewEmployeeData.idProofImageObject?.uri ? (
                                                                        <Box sx={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden', cursor: 'pointer' }} onClick={() => window.open(`${process.env.REACT_APP_API_URL}${viewEmployeeData.idProofImageObject.uri}`, '_blank')}>
                                                                            <img
                                                                                src={`${process.env.REACT_APP_API_URL}${viewEmployeeData.idProofImageObject.uri}`}
                                                                                alt="ID Proof"
                                                                                style={{ width: '100%', height: '40px', objectFit: 'cover' }}
                                                                            />
                                                                        </Box>
                                                                    ) : "No ID Uploaded"
                                                                }
                                                                icon="mdi:file-image-outline"
                                                                color="#3C0008"
                                                            />
                                                        </Box>
                                                    </Box>

                                                    {/* Section 2: Contact & Emergency */}
                                                    <Box>
                                                        <SectionHeader icon="mdi:contact-phone" title="Contact Info" color="#6d000e" />
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, bgcolor: '#ffffff', p: 2, borderRadius: '16px' }}>
                                                            <DetailItem label="Email Address" value={viewEmployeeData.email} icon="mdi:email-outline" color="#6d000e" />
                                                            <DetailItem label="Phone Number" value={viewEmployeeData.phoneNumber} icon="mdi:phone-outline" color="#6d000e" />
                                                            <DetailItem label="Emergency Contact" value={viewEmployeeData.emergencyContactPerson} icon="mdi:account-alert-outline" color="#6d000e" />
                                                            <DetailItem label="Emergency Phone" value={viewEmployeeData.emergencyContactNumber} icon="mdi:phone-alert-outline" color="#6d000e" />
                                                        </Box>
                                                    </Box>

                                                    {/* Section 3: Employment Details */}
                                                    <Box>
                                                        <SectionHeader icon="mdi:briefcase-outline" title="Employment" color="#3C0008" />
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, bgcolor: '#ffffff', p: 2, borderRadius: '16px' }}>
                                                            <DetailItem label="Joining Date" value={viewEmployeeData.dateOfJoining ? dayjs(viewEmployeeData.dateOfJoining).format("DD/MM/YYYY") : "-"} icon="mdi:calendar-check" color="#3C0008" />
                                                            <DetailItem label="Resignation" value={viewEmployeeData.dateOfResignation ? dayjs(viewEmployeeData.dateOfResignation).format("DD/MM/YYYY") : "-"} icon="mdi:calendar-remove" color="#3C0008" />
                                                            <DetailItem
                                                                label="Assigned Stores"
                                                                value={
                                                                    (Array.isArray(viewEmployeeData.store) && viewEmployeeData.store.length > 0)
                                                                        ? viewEmployeeData.store.map(s => s.storeName || s.branchName || (typeof s === 'string' ? s : "")).filter(Boolean).join(", ")
                                                                        : (viewEmployeeData.storeName || viewEmployeeData.branchName || (Array.isArray(viewEmployeeData.storeIds) && viewEmployeeData.storeIds.length > 0 ? viewEmployeeData.storeIds.join(", ") : "-"))
                                                                }
                                                                icon="mdi:store-outline"
                                                                fullWidth
                                                                color="#3C0008"
                                                            />
                                                        </Box>
                                                    </Box>

                                                    {/* Section 4: Address Details */}
                                                    <Box>
                                                        <SectionHeader icon="mdi:map-marker-outline" title="Addresses" color="#6d000e" />
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, bgcolor: '#ffffff', p: 2, borderRadius: '16px' }}>
                                                            <DetailItem label="Current Address" value={viewEmployeeData.currentAddress} icon="mdi:home-outline" color="#6d000e" />
                                                            <DetailItem label="Permanent Address" value={viewEmployeeData.permanentAddress} icon="mdi:home-city-outline" color="#6d000e" />
                                                        </Box>
                                                    </Box>

                                                </Box>
                                            </Box>

                                            {/* Actions Footer */}
                                            <Box sx={{ px: 4, py: 2, borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', bgcolor: '#f8fafc' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => setIsViewEmployeePopup(false)}
                                                    sx={{
                                                        background: '#3C0008',
                                                        borderRadius: '12px',
                                                        px: 4,
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        fontSize: '14px',
                                                        '&:hover': { background: '#3C0008', boxShadow: '0 4px 12px rgba(26,30,39,0.2)' }
                                                    }}
                                                >
                                                    Close
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Modal>
                                )}
                            </>


                        )
                    }
                    {
                        isAddStore && (
                            <div className="popup-overlay">
                                <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                    <Icon
                                        icon={closeIcon}
                                        className="popup-close-icon-outside"
                                        onClick={() => setIsAddStore(false)}
                                    />
                                    <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                        <AddStoreForm
                                            onSuccess={() => {
                                                setIsAddStore(false);
                                                // Trigger store reload/refresh if needed
                                                // For now just close, user can re-search
                                            }}
                                            onCancel={() => setIsAddStore(false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </main >
                <Footer />
            </div >

            {/* Role Management Modal (Add / Edit / List) */}
            {isAddRoleModalOpen && (
                <div className="popup-overlay" style={{ zIndex: 10000 }}>
                    <div className="user-popup-wrapper" style={{ maxWidth: '440px', width: '92%', height: 'auto', maxHeight: '88vh', overflowY: 'auto', padding: '26px' }}>
                        <Icon
                            icon={closeIcon}
                            className="popup-close-icon-outside"
                            onClick={() => {
                                setIsAddRoleModalOpen(false);
                                setEditingRoleId(null);
                                setEditingRoleOldName("");
                                setNewRoleData({ roleName: '' });
                            }}
                        />
                        <Typography variant="h6" textAlign="center" mb={1} style={{ fontWeight: 600 }}>
                            {editingRoleId ? "Edit Role" : "Add New Role"}
                        </Typography>
                        {editingRoleId && (
                            <p style={{ textAlign: 'center', fontSize: '12px', color: '#64748b', marginBottom: '16px' }}>
                                Modifying role: <strong style={{ color: '#0f172a' }}>{editingRoleOldName}</strong>
                            </p>
                        )}
                        <div className="employee-form-group" style={{ marginBottom: '20px' }}>
                            <label className="input-label">Role Name <span className="required">*</span></label>
                            <input
                                type="text"
                                className="category-input"
                                placeholder="e.g. Senior Stylist"
                                value={newRoleData.roleName}
                                onChange={e => setNewRoleData(prev => ({ ...prev, roleName: e.target.value }))}
                                autoFocus
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '12px', marginBottom: dynamicRoles.length > 0 ? '22px' : '0' }}>
                            <button
                                type="button"
                                className="cancel-Product-button"
                                style={{ flex: 1, padding: '10px' }}
                                onClick={() => {
                                    if (editingRoleId) {
                                        setEditingRoleId(null);
                                        setEditingRoleOldName("");
                                        setNewRoleData({ roleName: '' });
                                    } else {
                                        setIsAddRoleModalOpen(false);
                                    }
                                }}
                            >
                                {editingRoleId ? "Cancel Edit" : "Cancel"}
                            </button>
                            <button
                                type="button"
                                className="Add-Product-button"
                                style={{ flex: 1, padding: '10px' }}
                                onClick={handleSaveRole}
                            >
                                {editingRoleId ? "Save Changes" : "Create Role"}
                            </button>
                        </div>

                        {/* Existing Custom Roles list for quick management */}
                        {dynamicRoles.length > 0 && (
                            <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px', marginTop: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <span style={{ fontSize: '12px', fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Manage Custom Roles ({dynamicRoles.length})
                                    </span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '180px', overflowY: 'auto' }}>
                                    {dynamicRoles.map(role => (
                                        <div
                                            key={role._id || role.roleName}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '8px 12px',
                                                backgroundColor: editingRoleId === role._id ? '#eff6ff' : '#f8fafc',
                                                border: editingRoleId === role._id ? '1px solid #93c5fd' : '1px solid #e2e8f0',
                                                borderRadius: '8px'
                                            }}
                                        >
                                            <span style={{ fontSize: '13px', fontWeight: 600, color: '#1e293b' }}>
                                                {role.roleName}
                                            </span>
                                            <div style={{ display: 'flex', gap: '6px' }}>
                                                <Tooltip title={`Edit ${role.roleName}`}>
                                                    <div
                                                        onClick={() => handleOpenEditRoleModal(role)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '5px 7px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#ffffff',
                                                            border: '1px solid #cbd5e1',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            color: '#2563eb'
                                                        }}
                                                    >
                                                        <Icon icon="mdi:pencil-outline" width={16} height={16} />
                                                    </div>
                                                </Tooltip>
                                                <Tooltip title={`Delete ${role.roleName}`}>
                                                    <div
                                                        onClick={() => handleDeleteRole(role)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '5px 7px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#ffffff',
                                                            border: '1px solid #cbd5e1',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            color: '#ef4444'
                                                        }}
                                                    >
                                                        <Icon icon="mdi:trash-can-outline" width={16} height={16} />
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div >
    );
};


export default EmployeePage;